export default __webpack_public_path__ + "static/media/SS.a3c3eb0f.jpg";